<template>
  <div class="wrapper">
    <textarea maxlength='-1' placeholder="请根据题干写下你的答案" v-model="myAnswer" class="textarea" @input="onInput"></textarea>
    <answer :test="test" v-if="showAnswer"></answer>
  </div>
</template>

<script>
import answer from './answer.vue'
export default {
  components: {
    answer,
  },
  name: 'short-answer-test',
  props: {
    choiceAnswer: {
      type: String,
      default: () => ''
    },
    tempResult: {
      type: String,
      default: () => ''
    },
    test: {
      type: Object,
      default: () => ({})
    },
    testId: {
      type: Number,
      default: () => null,
    },
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      myAnswer: ''
    }
  },

  watch: {
    testId() {
      this.myAnswer = '';
      this.initAnswer();
    },
    tempResult(newValue) {
      if (newValue !== undefined && newValue !== null) {
        this.myAnswer = newValue;
      }
    },
    choiceAnswer(newValue) {
      if (!newValue) {
        return;
      }
      if (!this.tempResult) {
        this.myAnswer = newValue;
      }
    }
  },

  created() {
    this.initAnswer();
  },

  methods: {
    initAnswer() {
      // 优先使用 tempResult，如果没有再使用 choiceAnswer
      if (this.tempResult !== undefined && this.tempResult !== null && this.tempResult !== '') {
        this.myAnswer = this.tempResult;
      } else if (this.choiceAnswer) {
        this.myAnswer = this.choiceAnswer;
      }
    },
    onInput() {
      this.$emit('selectChange', this.myAnswer);
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.textarea {
  margin-bottom: 15px;
  padding: 15px;
  height: 178px;
  width: 100%;
  box-sizing: border-box;
  -webkit-appearance: none;
  border: 1px solid #eee;
  box-shadow: 0 0 5px 1px #eee;
  word-wrap: break-word;
  font-size: 15px;
}

textarea:focus {
  outline: none;
}
</style>
